import { useEffect, useState } from "react";
import { ApiError, GENERIC_ERROR, getApi } from "../../utils/api.ts";
import { accessToken } from "../../utils/auth.ts";
import { showError } from "../../utils/toast.ts";

/** Cancels obsolete requests when filters, tabs, or refresh keys change. */
export function useRoleManagementQuery<T>(url: string | null, refreshKey = 0) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(Boolean(url));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setData(null);
    setError(null);
    setLoading(Boolean(url));
    if (url) {
      void getApi<T>(url, accessToken(), "json", controller.signal)
        .then((response) => {
          if (!controller.signal.aborted) setData(response.data);
        })
        .catch((cause: unknown) => {
          if (!controller.signal.aborted) {
            const message = cause instanceof ApiError ? cause.message : GENERIC_ERROR;
            setError(message);
            showError(message, { id: `role-management-error:${message}` });
          }
        })
        .finally(() => {
          if (!controller.signal.aborted) setLoading(false);
        });
    }
    return () => controller.abort();
  }, [url, refreshKey]);

  return { data, loading, error };
}
